<template>
  <div class="main-content-container">
    <print-result ref="printComponent" />
    <app-header :step="3" />
    <div class="step">
      <div class="step-header">
        <h3>{{ $t("steps.step3") }}</h3>
        <router-link
          class="back"
          @click.native="handleGoBack"
          to="/handleGoBack"
        >
          <i class="far fa-arrow-left"></i>
          <span>{{ $t("buttons.back") }}</span>
        </router-link>
      </div>
      <third-step-form />
      <result-info
        :bikesCount="bikesCount"
        :bestSellers="areBestsellers"
        :lastStep="true"
      />
      <div class="step-actions">
        <i
          v-if="bikesCount"
          class="far fa-print btn-custom-print"
          :title="$t('buttons.print')"
          @click="printToPDFHandler"
        />
        <i
          class="far fa-copy btn-custom-copy"
          :title="$t('buttons.copy')"
          @click="handleCopyLink"
        />
      </div>
      <div class="step-summary no-margin" ref="stepSummary">
        <bike-tile-list
          v-if="bikesReady && bikesIds.length"
          :bikesIds="bikesIds"
          :bikesCount="bikesCount"
        />
      </div>
    </div>
    <transition name="fade">
      <a @click="handleScrollTop" v-if="visible" class="btn-scroll-top">
        <i class="far fa-arrow-up"></i>
      </a>
    </transition>
  </div>
</template>
<script>
// vuex
import { mapFields } from "vuex-map-fields";

// components
import AppHeader from "@/components/App/AppHeader";
import BikeTileList from "@/components/Bikes/BikeTileList";
import ThirdStepForm from "@/components/Forms/ThirdStepForm";
import ResultInfo from "@/components/App/ResultInfo";
import PrintResult from "@/components/App/PrintResult";

// css
import "./Step.scss";

export default {
  name: "ThirdStep",
  data() {
    return {
      visible: false,
      bikesCount: 0,
      bikesIds: null,
      bikesReady: false,
      timeoutId: null,
      fromRoute: null,
      bikesIdForPrint: null,
      areBestsellers: false,
    };
  },
  computed: {
    ...mapFields(["filters"]),
  },
  watch: {
    filters: {
      deep: true,
      async handler() {
        if (this.timeoutId != null) {
          window.clearTimeout(this.timeoutId);
        }

        window.setTimeout(() => {
          this.getBikesIds();
        }, 1000);
      },
    },
  },
  methods: {
    handlePrintPage: function () {
      window.print();
    },
    handleGoBack: function () {
      if (this.fromRoute && this.fromRoute.name == "firstStep") {
        this.$router.push({ name: `firstStep` });
      } else {
        this.$router.push({ name: `secondStep` });
      }
    },
    printToPDFHandler() {
      this.$refs.printComponent.show(this.bikesIds);
    },
    handleCopyLink: function () {
      navigator.clipboard
        .writeText(window.location.href)
        .then(() => {
          this.$notify({
            text: "Skopiowano do schowka",
            type: "success ",
            classes: "custom-notification",
          });
        })
        .catch((err) => {
          this.$notify({
            text: "Błąd! Nie udało się skopiować url",
            type: "error ",
            classes: "custom-notification",
          });
        });
    },
    handleScroll: function () {
      let bikesContainerEl = this.$refs.stepSummary;
      let bikesContainerElDistanceToTop =
        window.pageYOffset + bikesContainerEl.getBoundingClientRect().top;
      let diff = bikesContainerElDistanceToTop - window.scrollY;

      if (diff < 5) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
    handleScrollTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollToResults() {
      const el = this.$refs.stepSummary;
      el.scrollIntoView({ behavior: "smooth" });
    },
    getBestsellerBikesIds: function () {
      this.$store.dispatch("getBestsellerBikesIds").then((res) => {
        this.bikesCount = res.bikesCount;
        this.bikesIds = res.bikesIds;
        this.bikesReady = true;
      });
    },
    getBikesIds: async function () {
      await this.$store.dispatch("getBikesIds").then((res) => {
        if (res.bikesCount === 0 && !res.bikesIds.length) {
          this.getBestsellerBikesIds();
          this.areBestsellers = true;
        } else {
          this.bikesCount = res.availableCount;
          this.bikesIds = res.bikesIds;
          this.areBestsellers = false;
          this.bikesReady = true;
        }
      });
    },
  },
  async mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.$route.name === "thirdStepAllResults") {
      setTimeout(() => {
        this.scrollToResults();
      }, 100);
    }
    await this.getBikesIds();
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRoute = from;
    });
  },
  components: {
    AppHeader,
    BikeTileList,
    ThirdStepForm,
    ResultInfo,
    PrintResult,
  },
};
</script>
<style scoped lang="scss">
.fade-enter-active {
  transition: 0.5s ease;
}

.fade-leave-active {
  transition: 0.3s ease;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}
</style>
